var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8601 3.6259C10.2506 4.01643 10.2506 4.64959 9.8601 5.04011L6.90054 7.99967L18.4863 7.99967C24.1933 7.99967 28.8197 12.6261 28.8197 18.333C28.8197 24.04 24.1933 28.6663 18.4863 28.6663C12.7794 28.6663 8.153 24.04 8.153 18.333C8.153 17.7807 8.60071 17.333 9.153 17.333C9.70528 17.333 10.153 17.7807 10.153 18.333C10.153 22.9354 13.884 26.6663 18.4863 26.6663C23.0887 26.6663 26.8197 22.9354 26.8197 18.333C26.8197 13.7306 23.0887 9.99967 18.4863 9.99967L6.90054 9.99967L9.8601 12.9592C10.2506 13.3498 10.2506 13.9829 9.8601 14.3734C9.46958 14.764 8.83641 14.764 8.44589 14.3734L3.77922 9.70678C3.3887 9.31626 3.3887 8.68309 3.77922 8.29257L8.44589 3.6259C8.83641 3.23538 9.46958 3.23538 9.8601 3.6259Z",
    fill: "#131542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetArrow);
export default __webpack_public_path__ + "static/media/ResetArrow.b651adf42b3c7b11c331a18208b14315.svg";
export { ForwardRef as ReactComponent };